import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import Header from "@/components/Header";
import Footer from "@/components/Footer";
import CartDrawer from "@/components/CartDrawer";
import WhatsAppButton from "@/components/WhatsAppButton";
import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import { LanguageProvider } from "@/lib/i18n";

import Home from "@/pages/Home";
import Category from "@/pages/Category";
import ProductDetail from "@/pages/ProductDetail";
import Checkout from "@/pages/Checkout";
import OrderConfirm from "@/pages/OrderConfirm";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Account from "@/pages/Account";
import Admin from "@/pages/Admin";
import Contact from "@/pages/Contact";
import Legal from "@/pages/Legal";
import CookieBanner from "@/components/CookieBanner";

export default function App() {
  return (
    <div className="App min-h-screen flex flex-col">
      <BrowserRouter>
        <LanguageProvider>
          <AuthProvider>
            <CartProvider>
            <Header />
            <CartDrawer />
            <main className="flex-1">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/categorie/:slug" element={<Category />} />
                <Route path="/produs/:slug" element={<ProductDetail />} />
                <Route path="/checkout" element={<Checkout />} />
                <Route path="/checkout/success" element={<RedirectToConfirm />} />
                <Route path="/comanda/:orderId" element={<OrderConfirm />} />
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="/cont" element={<Account />} />
                <Route path="/admin" element={<Admin />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/termeni-si-conditii" element={<Legal />} />
                <Route path="/politica-de-confidentialitate" element={<Legal />} />
                <Route path="/politica-de-cookies" element={<Legal />} />
                <Route path="/politica-de-retur" element={<Legal />} />
                <Route path="/politica-de-livrare" element={<Legal />} />
                <Route path="/politica-de-garantie" element={<Legal />} />
                <Route path="/informatii-plati" element={<Legal />} />
              </Routes>
            </main>
            <Footer />
            <WhatsAppButton />
            <CookieBanner />
            <Toaster position="top-center" toastOptions={{ style: { borderRadius: 0, border: '1px solid #111827' } }} />
          </CartProvider>
        </AuthProvider>
        </LanguageProvider>
      </BrowserRouter>
    </div>
  );
}

function RedirectToConfirm() {
  // Stripe success_url uses /checkout/success?session_id=...&order_id=...
  const params = new URLSearchParams(window.location.search);
  const orderId = params.get("order_id");
  const sessionId = params.get("session_id");
  if (orderId) {
    const url = `/comanda/${orderId}${sessionId ? `?session_id=${sessionId}` : ""}`;
    window.location.replace(url);
  }
  return <div className="max-w-3xl mx-auto px-6 py-32 text-center text-gray-400 uppercase tracking-widest text-sm">Te redirecționăm...</div>;
}
